/** Public visibility requires an explicit publication flag and a reached schedule. */
export const isPublishedNow = (item: any, now = Date.now()): boolean => {
  if (!item || ![true, 1, '1', 'true'].includes(item.published)) return false;
  if (item.public_date == null || item.public_date === '') return true;
  const date = String(item.public_date);
  const scheduled = new Date(item.public_time && /^\d{4}-\d{2}-\d{2}$/.test(date)
    ? `${date}T${item.public_time}` : date).getTime();
  return Number.isFinite(scheduled) && scheduled <= now;
};

// Relationship wrappers carry IDs too; only inspect actual content/POI records.
export const filterPublishedRelations = (value: any, now = Date.now()): any => {
  if (Array.isArray(value)) return value.map(item => filterPublishedRelations(item, now)).filter(item => item != null);
  if (!value || typeof value !== 'object') return value;
  const record = ('content_id' in value || 'point_of_interest_id' in value)
    && !('point_of_interest' in value) && !('content' in value)
    && !('route_point_of_interest_id' in value)
    && ('published' in value || 'title' in value || 'name' in value || 'public_date' in value);
  if (record && !isPublishedNow(value, now)) return null;
  const result: any = {};
  for (const [key, item] of Object.entries(value)) {
    if ((key === 'point_of_interest' || key === 'content') && item && typeof item === 'object' && !isPublishedNow(item, now)) return null;
    result[key] = filterPublishedRelations(item, now);
    if ((key === 'point_of_interest' || key === 'content') && item != null && result[key] == null) return null;
  }
  return result;
};
